import React from 'react';
import { Check } from 'lucide-react';
import { Field, FieldContent, FieldLabel } from '@/Components/shadcn';
import { cn } from '@/lib/utils';

export interface BaseTestCardHeaderProps {
    testName: string;
    fieldName: string;
    checked: boolean;
}

function BaseTestCardHeader({ testName, fieldName, checked }: BaseTestCardHeaderProps): React.JSX.Element {
    const id = `${fieldName}-test-card`;

    return (
        <div className="pointer-events-none row-span-1 flex h-full flex-row items-start justify-center gap-2 p-2.5">
            <Field orientation="horizontal" className="h-full has-[>[data-slot=field-content]]:items-center">
                <div
                    id={id}
                    data-cy={testName}
                    className={cn(
                        'border-primary relative mt-0.5 flex size-4 min-h-4 min-w-4 shrink-0 items-center justify-center rounded border shadow-xs',
                        checked && 'bg-primary text-primary-foreground',
                    )}
                >
                    {checked && <Check className="size-3.5 text-current transition-none" />}
                </div>
                <FieldContent>
                    <FieldLabel htmlFor={id} className="text-foreground text-base leading-tight">
                        {testName}
                    </FieldLabel>
                </FieldContent>
            </Field>
        </div>
    );
}

export default BaseTestCardHeader;
